// context/LanguageProvider.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getGreekOn, changeGreekOn } from "../apiHandles/user_progress";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [selLanguage, setSelLanguage] = useState(() => {
        const cached = localStorage.getItem('greekOn');
        return cached === 'true'; // Default to Greek if not set
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchLanguage = async () => {
            // Check if user is authenticated before making API call
            const accessToken = localStorage.getItem("access");
            const refreshToken = localStorage.getItem("refresh");

            // If user is not logged in, just use localStorage value and don't call API
            if (!accessToken && !refreshToken) {
                setIsLoading(false);
                return;
            }

            try {
                const serverLanguage = await getGreekOn();
                setSelLanguage(serverLanguage);
                localStorage.setItem('greekOn', serverLanguage.toString());
            } catch (error) {
                console.error("Error fetching language preference:", error);
                // If error is due to authentication, just use localStorage value
                // Don't show alerts for unauthenticated users
            } finally {
                setIsLoading(false);
            }
        };
        fetchLanguage();
    }, []);

    useEffect(() => {
        const root = document.documentElement;
        root.classList.toggle("lang-el", selLanguage);
        root.classList.toggle("lang-en", !selLanguage);
        root.setAttribute("lang", selLanguage ? "el" : "en");
    }, [selLanguage]);

    const toggleLanguage = async () => {
        try {
            const newValue = !selLanguage;
            setSelLanguage(newValue);
            localStorage.setItem('greekOn', newValue.toString());
            await changeGreekOn();
        } catch (error) {
            console.error("Error toggling language:", error);
            // Rollback on error
            setSelLanguage(!selLanguage);
        }
    };

    return (
        <LanguageContext.Provider value={{ selLanguage, toggleLanguage, isLoading }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLanguage must be used within LanguageProvider");
    }
    return context;
};